var map = {
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_00.jpg": 1996,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_01.jpg": 1997,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_02.jpg": 1998,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_03.jpg": 1999,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_04.jpg": 2000,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_05.jpg": 2001,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_06.jpg": 2002,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_07.jpg": 2003,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_08.jpg": 2004,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_09.jpg": 2005,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_10.jpg": 2006,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_11.jpg": 2007,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_12.jpg": 2008,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_13.jpg": 2009,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_14.jpg": 2010,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_15.jpg": 2011,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_16.jpg": 2012,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_17.jpg": 2013,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_18.jpg": 2014,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_19.jpg": 2015,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_20.jpg": 2016,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_21.jpg": 2017,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_22.jpg": 2018,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_23.jpg": 2019,
	"./Lightsaber Obi-Wan ANH - Img - Wip 6_24.jpg": 2020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1995;